var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"loading-screen"}},[_c('div',[_c('img',{staticClass:"animate__shakeY",attrs:{"src":require("../assets/group24_logo_colored.svg")}}),_vm._v(" "),(false)?_c('p',{staticClass:"mt-4"},[_vm._v("Generiere Teams")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20edc404","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TheLoadingScreen.vue
// module id = null
// module chunks = 